import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import InputField from './InputField';

function Inline(_ref) {
  var light = _ref.light,
      hover = _ref.hover,
      focus = _ref.focus,
      _ref$highlightColor = _ref.highlightColor,
      highlightColor = _ref$highlightColor === void 0 ? light ? 'light-0' : 'highlight' : _ref$highlightColor,
      restProps = _objectWithoutPropertiesLoose(_ref, ["light", "hover", "focus", "highlightColor"]);

  var pseudoStyles = restProps.readOnly || restProps.disabled ? {} : {
    backgroundColor: highlightColor
  };

  if (restProps.disabled) {
    restProps.cursor = 'not-allowed';
    restProps.tabIndex = undefined;
    restProps.opacity = 0.64;
  } else if (hover || focus) {
    restProps = _objectSpread(_objectSpread({}, restProps), pseudoStyles);
  }

  return /*#__PURE__*/React.createElement(InputField, _extends({
    autoWidth: true,
    backgroundColor: "transparent",
    color: light ? 'light-9' : 'foreground',
    focus: pseudoStyles,
    grow: 0,
    hover: pseudoStyles,
    marginHorizontal: -0.5,
    paddingHorizontal: 0.5,
    paddingVertical: 0,
    placeholderColor: light ? 'light-5' : 'foregroundTertiary',
    radius: 3,
    stroke: undefined
  }, restProps));
}

Inline.displayName = 'Input.Inline';
export default Inline;